export default __webpack_public_path__ + "static/media/dulces_perspective.cd09cb38.jpg";